<script lang="ts" setup>
import { Vue3Lottie } from 'vue3-lottie'
import { buildMeta } from "~~/utils/meta-builder";
import PortalJSON from "../assets/portal.json";
const controller = ref(null)
useHead(buildMeta({
	key:'subscribe', 
	follow: false
}))

const onComplete = () => {
   (controller.value as any).goToAndPlay(58, true);
 }

</script>

<template>
	
	<div class="overflow-x-hidden">
		<Header theme="light" />
		<div class="md:max-w-screen-xl mx-auto px-10 md:px-0 ">


			<!-- Subscribe -->

			<div class="relative overflow-hidden pb-8 md:pb-2 flex flex-col-reverse lg:flex-row items-center text-white bg-primary-500 rounded-2xl">

				<div class="flex-1 z-50 pb-16 pt-12 -mt-4" id="subscribe">
					<NewsletterForm class="ml-0 md:ml-10"  />

				</div>

				<div class="relative flex-1">

					
					<!-- Boy -->
					<!-- <nuxt-img src="boy-device.png" alt="smoxy for work teaser image" class="-mt-5 w-full h-full max-w-xl z-40" /> -->
					<div class="absolute -right-24 -top-[650px]">
						<client-only>
							<Vue3Lottie
								ref="controller"
								alt="Hand with device through portal"
								class="scale-[75%]"
								:animation-data="PortalJSON"
								:loop="false"
								@on-complete="onComplete"
								/>
						</client-only>
						
					</div>

				</div>
			</div>

			
		
		</div>
	
		<Footer />
	</div>
</template>